import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/base.less';
import 'element-ui/lib/theme-chalk/index.css';
import element from 'element-ui';
import axios from 'axios'

Vue.use(element)
Vue.config.productionTip = false
axios.defaults.baseURL = 'http://send.haichacha.net/' //线上接口
    // axios.defaults.baseURL = 'http://rswy.natapp4.cc/' //测试接口
Vue.prototype.$http = axios
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
    config.headers.token = window.localStorage.getItem('token')
    return config
})
axios.interceptors.response.use(response => {
    const data = response.data;
    if (data.code && response.config.url != 'app/userInfo') {
        if (data.code == 0) {
            return response;
        } else if (data.code == 401) {
            element.Message.error('登录过期，请重新登录');
            localStorage.clear();
            router.replace('/login');
        } else if (data.code == 411) {
            element.Message.error('当前账号已在其他设备登录');
            localStorage.clear();
            router.replace('/login');
        } else if (data.code == 1) {
            return response;
        } else {
            element.Message.error(data.msg);
        }
    } else {
        return response
    }
    return response
}, (err) => {
    element.Message.error('连接错误，请重试');
    return Promise.resolve(err);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
